var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from "react";
import RouterLink from "react-router-dom/Link";
import { Text } from "rebass";
import { theme } from "src/styles/theme";
import styled, { css } from "styled-components";
var linkStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    color: ", ";\n  }\n"])), theme.colors.text, theme.colors.primary);
var Link = styled(RouterLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), linkStyle, function (props) { return props.css; });
var LinkHref = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), linkStyle, function (props) { return props.css; });
var Item = memo(function (_a) {
    var icon = _a.icon, label = _a.label, reverse = _a.reverse, props = __rest(_a, ["icon", "label", "reverse"]);
    var renderItem = function () { return (React.createElement(React.Fragment, null,
        reverse && (React.createElement(Text, { css: "flex: 1 1 auto; white-space: nowrap;" }, label)),
        React.createElement(Text, { color: "primary", css: "flex: 0 0 auto; width: 2rem; height: 2rem; display: flex; justify-content: center; align-items:center;", "aria-hidden": "true" }, React.cloneElement(icon, { "aria-hidden": "true" })),
        !reverse && (React.createElement(Text, { css: "flex: 1 1 auto; white-space: nowrap;" }, label)))); };
    if ("to" in props) {
        return (React.createElement(Link, __assign({ to: props.to }, props, { css: "gap: .5rem;", role: "menuitem" }), renderItem()));
    }
    return (React.createElement(LinkHref, __assign({ href: props.href }, props, { css: "gap: .5rem;", role: "menuitem" }), renderItem()));
});
export default Item;
var templateObject_1, templateObject_2, templateObject_3;
